import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { LookupIconNamesMap } from 'src/constants/lookup.constants';

export enum EDIT_TOOLS {
  frame = 'frame',
  filters = 'filters',
  adjustments = 'adjustments',
  replace = 'replace',
  orientation = 'orientation',
  restore = 'restore',
  undo = 'undo',
  redo = 'redo',
}

export const BaseToolbarIconNamesMap: Partial<Record<string, ICON_NAMES>> = {
  ...LookupIconNamesMap,
  [EDIT_TOOLS.frame]: ICON_NAMES.Crop,
  [EDIT_TOOLS.filters]: ICON_NAMES.Filters,
  [EDIT_TOOLS.adjustments]: ICON_NAMES.Settings2,
  [EDIT_TOOLS.replace]: ICON_NAMES.Refresh,
  [EDIT_TOOLS.restore]: ICON_NAMES.CounterClockwise,
  [EDIT_TOOLS.undo]: ICON_NAMES.Undo,
  [EDIT_TOOLS.redo]: ICON_NAMES.Redo,
  [EDIT_TOOLS.orientation]: ICON_NAMES.Orientation,
};
